import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=650222a0&scoped=true"
import script from "./BatchImport.vue?vue&type=script&lang=js"
export * from "./BatchImport.vue?vue&type=script&lang=js"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=650222a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650222a0",
  null
  
)

export default component.exports